/** @format */
import { useDispatch, useSelector } from 'react-redux';
import { useEffect, useState } from 'react';
import { ItemLoaders } from '../../../core/loaders/ItemLoaders';
import { FormGeneralHelper } from '../../../helpers/FormGeneral';
import Filter from '../../../interfaces/forms/Filter';
import Order from '../../../interfaces/forms/Order';
import { DiscountCollectionInterface } from '../../../interfaces/api/DiscountCollectionInterface';
import { DISCOUNT_CONSTANTS } from '../../discounts/reducers';
import { ProductActionField, ProductActions } from '../../simcard/ProductReducer';
import { SimpleSelectElements } from '../../../components/Adescom/SimpleSelect';

export const useDiscountsHook = (filters: Array<Filter>, orders: Array<Order>): DiscountCollectionInterface | null => {
    const dispatch = useDispatch();
    const { discounts } = useSelector((state: { productReducers: ProductActionField }) => state.productReducers);
    const [call, setCall] = useState(false);
    useEffect(() => {
        if (!discounts && !call) {
            setCall(true);
            const itemLoader = new ItemLoaders(dispatch);
            itemLoader.getListWithCallback(
                FormGeneralHelper.getByUri(FormGeneralHelper.getPath('/discounts')),
                DISCOUNT_CONSTANTS.LIST,
                filters,
                orders,
                (data: DiscountCollectionInterface | null) => {
                    dispatch({
                        type: ProductActions.PRODUCT_GET_ALLOWED_DISCOUNT_LIST,
                        discounts: data,
                    } as ProductActionField);
                },
                { propagateDataToCallback: true, dispatchAfterCallback: false }
            );
        }
    }, [dispatch, filters, orders, discounts, call]);
    return discounts ?? null;
};

export const useDiscountSimpleSelectElements = (discounts?: DiscountCollectionInterface | null): Array<SimpleSelectElements> => {
    const elements: Array<SimpleSelectElements> = [];
    if (!discounts) {
        return elements;
    }
    for (let i = 0; i < discounts['hydra:member'].length; i++) {
        elements.push({ name: discounts['hydra:member'][i].mainname ?? 'no-name', value: discounts['hydra:member'][i].id ?? -1 });
    }
    return elements;
};
